import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyC0Rr6L5OQaGYVIoBTIMIUFkYsp6E0Kuzs",
    authDomain: "customer-food-fc7b1.firebaseapp.com",
    projectId: "customer-food-fc7b1",
    storageBucket: "customer-food-fc7b1.appspot.com",
    messagingSenderId: "503288531916",
    appId: "1:503288531916:web:451cf131360c5f902b2b69"
};
const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);


export const RequestForToken = () => {
    return getToken(messaging, { vapidKey: 'BKyft6oEB9HsZwXAxf_heelksxk8ZPSITRQEhK-cRBGUElshjcD7OzIQL5MMwLpYutpaYTNGaWsS2S-8WdWA-Bo' })
        .then((currentToken) => {
            if (currentToken) {
                localStorage.setItem("FCM",currentToken)
            } else {
                console.log('No registration token available. Request permission to generate one.');
            }
        })
        .catch((err) => {
            console.log('An error occurred while retrieving token. ', err);
        });
};

initializeApp(firebaseConfig);